module.exports = __webpack_public_path__ + "img/rg-active.02920c11.png";